import { RenewalOptions } from "../models";

export const getNextRenewalDate = (options: RenewalOptions): Date => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // Reset to start of the day

  const periodInMonths = options.periodInMonths;
  let renewalDate = new Date(options.startDate);
  renewalDate.setHours(0, 0, 0, 0); // Reset to start of the day

  while (renewalDate <= currentDate) {
    renewalDate.setMonth(renewalDate.getMonth() + periodInMonths);
  }

  return renewalDate;
};
